export enum ApiErrorStatus {
  'INTERNAL' = 500,
  'FORBIDDEN' = 403,
  'UNAUTHORIZED' = 401,
  'VALIDATION' = 422
}
